import React from 'react';
import { motion } from 'framer-motion';
export function Terms() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen py-20" data-id="element-544" data-mp="3tp0oe5lgrot1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-545" data-mp="2h4tkm1yr94w">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-546" data-mp="79pndnkvdm8f">
          Terms of Service
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-547" data-mp="c7zhduuuygsg">
          <p className="text-lg font-medium text-slate-900" data-id="element-548" data-mp="g8jhn7aqa0it">
            Last Updated: May 19, 2026
          </p>
          <p data-id="element-549" data-mp="la0ij2t7pmze">
            By accessing or using the Daily Care Pharmacy website, you agree to
            be bound by these Terms of Service. Please read them carefully
            before using our services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-550" data-mp="2rznfvupishdd">
            Use of Services
          </h2>
          <p data-id="element-551" data-mp="23932a5qfxwkm">
            Our services are intended for personal, non-commercial use. You
            agree to provide accurate information when requesting prescription
            refills or clinical services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-552" data-mp="1tirug83mz38g">
            Medical Disclaimer
          </h2>
          <p data-id="element-553" data-mp="1pj9cnl74389u">
            The information provided on this website is for informational
            purposes only and is not a substitute for professional medical
            advice, diagnosis, or treatment. Always seek the advice of your
            physician or other qualified health provider.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-554" data-mp="2d5zbkdo5ymq8">
            Limitation of Liability
          </h2>
          <p data-id="element-555" data-mp="28ak1lwta1az3">
            Daily Care Pharmacy shall not be liable for any direct, indirect,
            incidental, or consequential damages arising out of your use of our
            website or services.
          </p>
        </div>
      </div>
    </motion.div>;
}